<!--
    课程商品-耗课统计
    作用：耗课统计列表数据
    组件:旧版本
-->
<template>
  <div>
    <div class="top-data">
      <p>商品名称：{{ topData.name }}</p>
      <p>商品编码：{{ topData.code }}</p>
      <p>上架时间：{{ topData.publish_time }}</p>
    </div>

    <AppList
      ref="list"
      :list.sync="list"
      :columns="columnsLiveAll"

      :columns-check="columnsLive"
      :api-type="apiUrl"
      :api="apiUrl"

      title=""
      @checkedColumns="checkedColumns">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArrLive"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columnsLive"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="300px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-button
                class="opt-btn"
                size="small"
                @click="editSee(scope.row.id)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>

    <el-dialog
      v-if="dialogDetail.show"
      :visible.sync="dialogDetail.show"
      title="查看详情"
      width="1000px">
      <AppList
        :list.sync="dialogDetail.list"
        :api="dialogDetail.api"
        title="">
        <template slot-scope="props">
          <el-table :data="props.listData">
            <el-table-column
              v-for="column in dialogDetail.column"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :width="column.width"
              :formatter="column.formatter"
            />
          </el-table>
        </template>
      </AppList>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="dialogDetail.show = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'GoodsTimeStatistics',
  data() {
    return {
      list: {},
      apiUrl: '',
      id: this.$route.query.id,
      columnsLive: [],
      columnsLiveAll: [
        {
          label: '直播时间',
          width: '180px',
          disabled: true,
          formatter: (row) => {
            let time = '';
            switch (row.status) {
              case 1: // 未开始 展示预设直播开始时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 2: // 直播中 展示实际直播开始时间~--
                time = `${row.begin_time} ~ --`;
                break;
              case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                time = `${row.begin_time} ~ ${row.close_time}`;
                break;
              case 4: // 缺课 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 5: // 已取消 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              default:
                break;
            }
            return time;
          },
        },
        {
          label: '直播时长',
          formatter: (row) => {
            const time = this.$setting.setTime(row.act_liveroom_second);
            return `${time.hour}:${time.min}:${time.sec}`;
          },
        },
        /* {
          label: '直播消费金额',
          formatter: row => {
            return this.$setting.toDecimal(row.bill_teaching_amount, 2);
          },
          show: this.$route.query.factor !== 'factor'
        },
        {
          label: '录制消费金额',
          formatter: row => {
            return this.$setting.toDecimal(row.bill_record_amount, 2);
          },
          show: this.$route.query.factor !== 'factor'
        }, */
        { prop: 'name', label: '课题', disabled: true },
        { prop: 'number', label: '教室编号' },
        { prop: 'teacher_name', label: '授课老师', disabled: true },
        { prop: 'teacher_mobile', label: '手机号' },
        {
          label: '直播类型',
          formatter: (row) => {
            const type = {
              1: '班级直播间',
              2: '链接直播间',
              3: '线下课',
            };
            return type[row.type];
          },
        },
        {
          label: '选课类型',
          prop: 'course_type_text',
          /* formatter: row => {
            const type = {
              1: 'AI课件',
              2: 'AI双师课件',
              3: '互动课件',
              4: '其他',
              0: '其他'
            };
            return type[row.course_type]
          } */
        },
        { prop: 'course_name', label: '课时名称' },
        { prop: 'bill_course_amount', label: '消费金币' },
        // { prop: 'name6', label: '课件类型' }, // 缺少
        // { prop: 'name7', label: '课件名称' }, // 缺少
        {
          label: '直播状态',
          formatter: (row) => {
            const status = {
              1: '未开始',
              2: '直播中',
              3: '已结束',
              4: '缺课',
              5: '已取消',
            };
            return status[row.status];
          },
        },
        // { prop: 'video_type', label: '授课类型' }, // 缺少
        { prop: 'student_count', label: '学生数' },
        { prop: 'act_student_count', label: '上课总人次', disabled: true },
        {
          label: '备注',
          formatter: row => (row.unpaid_record_numbers > 0 && row.unpaid_replay_numbers > 0 && unpaid_teaching_numbers > 0 ? '未结清' : ''),
        },
        // { prop: 'name12', label: '录课消费金额' }, // 缺少
        // { prop: 'name13', label: '回放消费金额' }, // 缺少
      ],

      dialogDetail: {
        show: false,
        list: {},
        column: [
          {
            prop: 'action',
            label: '操作动作',
            formatter: (row) => {
              const action = {
                1: '进入直播间',
                2: '退出直播间',
                3: '开始直播',
                4: '结束直播',
                5: '取消直播',
              };
              return action[row.action];
            },
          },
          { prop: 'created_at', label: '时间点' },
          {
            label: '直播时长（时分秒）',
            formatter: (row) => {
              const time = this.$setting.setTime(row.liveroom_second);
              return row.action === 4 ? `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}` : '00:00:00';
            },
          },
          { prop: 'act_student_count', label: '上课总人次' },
        ],
      },

      topData: {},

      searchList: {
        type: [
          { value: 1, name: '班级直播' },
          { value: 2, name: '链接直播' },
          { value: 3, name: '线下课' },
        ],
        course_type: [
          { value: 1, name: 'AI课件' },
          { value: 2, name: 'AI双师课件' },
          { value: 3, name: '互动课件' },
          { value: 4, name: '其他' },
        ],
      },
    };
  },
  computed: {
    searchArrLive() {
      const column = [
        { prop: 'name', label: '课题名称' },
        { prop: 'teacher_name', label: '授课老师' },
        { prop: 'teacher_mobile', label: '手机号' },
        { prop: 'number', label: '教室编号' },
        { prop: 'search_school_name', label: '校区名称' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        {
          selectValue: this.searchList.type,
          componentType: 'AppSearchStatus',
          searchType: 'type',
          placeholder: '请选择直播类型',
        },
        {
          selectValue: this.searchList.course_type,
          componentType: 'AppSearchStatus',
          searchType: 'course_type',
          placeholder: '请选择选课类型',
        },
        // {
        //   selectValue: [ // 缺少
        //     { value: 0, name: '互动课件' },
        //     { value: 1, name: '云盘文件' }
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'is_auth_minipro',
        //   placeholder: '请选择课件类型'
        // },
        // {
        //   selectValue: [
        //     { value: 1, name: '是' },
        //     { value: 0, name: '否' }
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'is_playback',
        //   placeholder: '请选择录制情况'
        // },
        // {
        //   selectValue: [ // 缺少
        //     { value: 0, name: '是' },
        //     { value: 1, name: '否' }
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'is_auth_minipro',
        //   placeholder: '请选择回放情况'
        // },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
  },
  created() {
    this.apiUrl = `/api/liveroom?equal[commodities_id]=${this.id}&order[begin_time]=desc`;

    this.$http.get(`/api/course/commodities/${this.id}`).then(res => this.topData = res.data);

    this.columnsLive = [
      {
        label: '直播时间',
        width: '180px',
        formatter: (row) => {
          let time = '';
          switch (row.status) {
            case 1: // 未开始 展示预设直播开始时间~--
              time = `${row.start_time} ~ --`;
              break;
            case 2: // 直播中 展示实际直播开始时间~--
              time = `${row.begin_time} ~ --`;
              break;
            case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
              time = `${row.begin_time} ~ ${row.close_time}`;
              break;
            case 4: // 缺课 预设时间~--
              time = `${row.start_time} ~ --`;
              break;
            case 5: // 已取消 预设时间~--
              time = `${row.start_time} ~ --`;
              break;
            default:
              break;
          }
          return time;
        },
      },
      {
        label: '直播时长',
        formatter: (row) => {
          const time = this.$setting.setTime(row.act_liveroom_second);
          // const dayHour = time.day > 0 ? (time.day * 24) + time.hour : time.hour;
          return `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
        },
      },
      {
        label: '直播消费金额',
        formatter: row => this.$setting.toDecimal(row.bill_teaching_amount, 2),
        show: this.factor !== 'factor',
      },
      {
        label: '录制消费金额',
        formatter: row => this.$setting.toDecimal(row.bill_record_amount, 2),
        show: this.factor !== 'factor',
      },
      { prop: 'name', label: '课题' },
      { prop: 'teacher_name', label: '授课老师' },
      { prop: 'act_student_count', label: '上课总人次' },
      {
        label: '直播类型',
        formatter: (row) => {
          const type = {
            1: '班级直播间',
            2: '链接直播间',
            3: '线下课',
          };
          return type[row.type];
        },
      },
      {
        label: '选课类型',
        prop: 'course_type_text',
        /* formatter: row => {
            const type = {
              1: 'AI课件',
              2: 'AI双师课件',
              3: '互动课件',
              4: '其他',
              0: '其他'
            };
            return type[row.course_type]
          } */
      },
      { prop: 'commodities_name', label: '商品名称' },
      { prop: 'commodities_code', label: '商品编码' },
      { prop: 'course_name', label: '课时名称' },
      { prop: 'commodities_consume_num', label: '耗课次数/学生数' },
      { prop: 'bill_course_amount', label: '消费金币' },
      {
        label: '备注',
        formatter: row => (row.unpaid_course_numbers > 0 || row.unpaid_record_numbers > 0 || row.unpaid_replay_numbers > 0 || row.unpaid_teaching_numbers > 0 ? '未结清' : ''),
      },
    ];
  },
  methods: {
    timeFamate(num) {
      return num > 9 ? num : `0${num}`;
    },
    editSee(_id) {
      this.dialogDetail.api = `/api/liveroom/teacher/action/${_id}`;
      this.dialogDetail.show = true;
    },

    // 选择列表字段
    checkedColumns(val) {
      const data = [];
      val.forEach((item) => {
        this.columnsLiveAll.forEach((v) => {
          if (v.label === item) {
            data.push(v);
          }
        });
      });
      this.$nextTick(() => {
        this.columnsLive = data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.top-data {
    display: flex;
    justify-content: space-between;
    max-width: 800px;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/views/Goods/goodsTimeStatistics.vue